var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field margin-right-10 select-project"},[(_vm.projects.length > 1)?_c('drop-down',{attrs:{"items":_vm.projects,"dataField":'Id',"textField":'Name',"selectedValue":_vm.projectId,"cssClass":'margin-right-10'},on:{"change":function($event){return _vm.onProjectChange($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f301d606","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Content/src/components/ProjectSelect.vue
// module id = 933
// module chunks = 1